const zh_hant = {
  price: "價格",
  vip_permission: "VIP權限",
  subscribe_option: "訂閱選項",
  unit: "單位",
  cost: "費用",
  permission: "權限",
  amount: "金額"
};
const zh_cn = {
  price: "价格",
  vip_permission: "VIP权限",
  subscribe_option: "订阅选项",
  unit: "单位",
  cost: "费用",
  permission: "权限",
  amount: "金额"
};
const en = {
  price: "Price",
  vip_permission: "VIP Permissions",
  subscribe_option: " subscribe",
  unit: "Unit",
  cost: "Price",
  permission: "Permissions",
  amount: "Amount"
};
const es = {
  price: "Precio",
  vip_permission: "Permisos VIP",
  subscribe_option: "Opciones de suscripción",
  unit: "Unidad",
  cost: "Precio",
  permission: "Permisos",
  amount: "Cantidad"
};
export default {
  zh_hant,
  en,
  zh_cn,
  es
};
